// Data Narasi Tujuan Program Studi oleh Ketua Program Studi
const kaprodiNarasi = [
  {
    id: 1,
    kodeProdi: "S1-KEP",
    namaProdi: "S1 Keperawatan",
    kaprodi: {
      nama: "Siska Wijayanti Pratiwi, S.Kep, Ns, M.Kes",
      foto: "/api/foto/struktur/siska-wijayanti-pratiwi-s-kep-ns-m-kes/foto/foto_1768013820.png",
      nip: null
    },
    tujuan: [
      "Menghasilkan lulusan yang memiliki kompetensi dalam memberikan asuhan keperawatan yang holistik, komprehensif, dan bermutu tinggi kepada individu, keluarga, dan masyarakat.",
      "Membentuk perawat profesional yang mampu berpikir kritis, kreatif, dan inovatif dalam menyelesaikan masalah kesehatan.",
      "Menyiapkan lulusan yang memiliki jiwa kepemimpinan dan mampu berkolaborasi dalam tim kesehatan interprofesional.",
      "Mengembangkan kemampuan riset keperawatan untuk berkontribusi dalam pengembangan ilmu keperawatan berbasis bukti."
    ],
    quote: "Keperawatan bukan hanya profesi, tetapi panggilan hati untuk melayani sesama dengan penuh kasih sayang dan profesionalisme.",
    visiProdi: "Menjadi program studi keperawatan unggul yang menghasilkan perawat profesional berkarakter, kompeten, dan berdaya saing global.",
    kompetensiLulusan: [
      "Memberikan asuhan keperawatan pada klien dengan berbagai gangguan kesehatan",
      "Melakukan komunikasi terapeutik dengan klien dan keluarga",
      "Menerapkan prinsip etik dan legal dalam praktik keperawatan",
      "Melakukan penelitian sederhana dalam bidang keperawatan",
      "Mengelola pelayanan keperawatan dengan kepemimpinan yang efektif"
    ]
  },
  {
    id: 2,
    kodeProdi: "NERS",
    namaProdi: "Profesi Ners",
    kaprodi: {
      nama: "H. Muslimin, S.Kep, Ns, M.Kep",
      foto: null,
      nip: null
    },
    tujuan: [
      "Menghasilkan Ners yang kompeten dalam memberikan asuhan keperawatan profesional di berbagai setting pelayanan kesehatan.",
      "Membentuk Ners yang mampu mengintegrasikan teori dan praktik keperawatan dalam pelayanan kepada pasien.",
      "Menyiapkan Ners yang memiliki kemampuan clinical reasoning dan clinical judgment yang baik.",
      "Mengembangkan sikap profesional, etis, dan caring dalam setiap tindakan keperawatan."
    ],
    quote: "Seorang Ners sejati adalah mereka yang tidak hanya merawat luka di tubuh, tetapi juga menyembuhkan luka di hati pasiennya.",
    visiProdi: "Menjadi program profesi Ners yang menghasilkan lulusan berkarakter caring, kompeten, dan siap berkiprah di kancah nasional maupun internasional.",
    kompetensiLulusan: [
      "Melakukan praktik keperawatan profesional secara mandiri",
      "Memberikan asuhan keperawatan pada kasus kompleks",
      "Melakukan tindakan keperawatan lanjutan dan spesialistik dasar",
      "Berkolaborasi efektif dengan tim kesehatan lainnya",
      "Menerapkan evidence-based nursing practice"
    ]
  },
  {
    id: 3,
    kodeProdi: "S1-KM",
    namaProdi: "S1 Kesehatan Masyarakat",
    kaprodi: {
      nama: "Nadirah, SKM, M.Kes",
      foto: null,
      nip: null
    },
    tujuan: [
      "Menghasilkan Sarjana Kesehatan Masyarakat yang mampu mengidentifikasi, menganalisis, dan memecahkan masalah kesehatan masyarakat.",
      "Membentuk lulusan yang kompeten dalam merencanakan, melaksanakan, dan mengevaluasi program kesehatan masyarakat.",
      "Menyiapkan tenaga kesehatan masyarakat yang mampu melakukan advokasi, pemberdayaan, dan kemitraan untuk meningkatkan derajat kesehatan masyarakat.",
      "Mengembangkan kemampuan riset epidemiologi dan analisis data kesehatan untuk pengambilan keputusan berbasis bukti."
    ],
    quote: "Kesehatan masyarakat adalah investasi terbaik untuk masa depan bangsa. Mari bersama membangun Indonesia yang sehat dan sejahtera.",
    visiProdi: "Menjadi program studi kesehatan masyarakat terkemuka yang menghasilkan lulusan profesional, inovatif, dan berkomitmen tinggi terhadap kesehatan masyarakat.",
    kompetensiLulusan: [
      "Melakukan surveilans dan investigasi wabah penyakit",
      "Merancang dan mengelola program promosi kesehatan",
      "Menganalisis determinan kesehatan masyarakat",
      "Mengelola sistem informasi kesehatan",
      "Melakukan advokasi kebijakan kesehatan"
    ]
  }
];

export default kaprodiNarasi;
